function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15 0C6.71584 0 0 6.71584 0 15C0 23.2843 6.71584 30 15 30C23.2843 30 30 23.2843 30 15C29.9901 6.71973 23.2802 0.00984192 15 0ZM15 28.125C7.7513 28.125 1.875 22.2487 1.875 15C1.875 7.7513 7.7513 1.875 15 1.875C22.2487 1.875 28.125 7.7513 28.125 15C28.1172 22.2455 22.2455 28.1172 15 28.125Z",
  fill: "url(#paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.0871 6.83716L10.5871 14.3371C10.2211 14.7034 10.2211 15.2966 10.5871 15.6628L18.0871 23.1628L19.4128 21.8371L12.5756 15L19.4128 8.16284L18.0871 6.83716Z",
  fill: "url(#paint1_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 0.813598,
  y1: 33.9468,
  x2: 30.9324,
  y2: 1.296,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 10.5594,
  y1: 25.3106,
  x2: 25.1169,
  y2: 16.5139,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF33B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#FEE72E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#FED51B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.196,
  stopColor: "#FDCA10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.281,
  stopColor: "#FDC70C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.669,
  stopColor: "#F3903F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.888,
  stopColor: "#ED683C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E93E3A"
})));

function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrowLeft.9fa37915.svg";
export { ForwardRef as ReactComponent };